<template>
  <footer id="Footer">
    <div class="main">
      <div class="company">
        <ul class="logo">
          <li><img src="" alt=""></li>
          <li><img src="" alt=""></li>
          <li><img src="" alt=""></li>
          <li><img src="" alt=""></li>
        </ul>
        <div class="aim">
          <span>共建强大的临床神经科学数字生态</span>
          <i>A Leading Online Platform for Clinical Neuroscience</i>
        </div>
        <p class="companyInfo">
          《脑医汇》是目前国内领先的临床神经科学互联网教育平台，平台包括学术主页、患者答疑、经典阅读、文章专栏、话题问答、文献速览、百家关注、会议系统、云课堂、病例夹等十大版块，涵括临床科研、临床实践相关的医学视频、学术主页、病例分享等内容，具备满足临床神经科学医生提供医学教育、交流、社交需求的功能。</p>
        <div class="phone">
          <img src="" alt="">
          <span>热线电话：800-000-000</span>
        </div>
      </div>
      <ul class="classify">
        <li>
          <h3>关于脑医汇</h3>
          <dl class="tab">
            <dd>关于我们</dd>
            <dd>联系我们</dd>
            <dd>加入我们</dd>
            <dd>在线咨询</dd>
            <dd>版权声明</dd>
            <dd>隐私保护</dd>
            <dd>免责条款</dd>
          </dl>
        </li>
        <li>
          <h3>关注我们</h3>
          <dl class="QR">
            <dd>
              <img src="" alt="">
              <span style="color:#019AB4">神外资讯公众号</span>
            </dd>
            <dd>
              <img src="" alt="">
              <span style="color:#023F84">神外资讯公众号</span>
            </dd>
          </dl>
        </li>
        <li>
          <h3>更多产品</h3>
          <dl class="QR">
            <dd>
              <img src="" alt="">
              <span style="color:#0581CE">神外资讯公众号</span>
            </dd>
            <dd>
              <img src="" alt="">
              <span style="color:#019AB4">神外资讯公众号</span>
            </dd>
            <dd>
              <img src="" alt="">
              <span style="color:#B84242">神外资讯公众号</span>
            </dd>
          </dl>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
  export default {
    name: "Footer",
    // components: {},
    // methods: {},
    // mounted: {}
  }

</script>

<style scoped lang="scss">
  footer {
    background: #EAEAEA;
    overflow: hidden;
    padding: 50px 0;
    margin-top: 20px;
  }

  .main {
    @extend %safetyWidth;
    display: flex;
  }

  .company {
    color: $theme_blue;
    flex: 1;

    .logo {
      display: flex;
      margin-bottom: 12px;

      li img {
        background: #6fc2f5;
        width: 60px;
        height: 60px;
        margin-right: 8px;
      }
    }

    .aim {
      display: flex;
      flex-direction: column;
      margin: 12px 0;

      span {
        font-size: 18px;
      }

      i {
        font-size: 12px;
      }
    }

    .companyInfo {
      font-size: 12px;
      color: #568AAB;
    }

    .phone {
      display: flex;
      align-items: center;
      margin-top: 14px;

      img {
        width: 16px;
        height: 16px;
        flex: 0 0 auto;
        margin-right: 10px;
        background: #6fc2f5;
      }

      span {
        font-size: 14px;
        color: #568AAB;
      }
    }
  }

  .classify {
    display: flex;
    margin-left: 50px;

    li {
      flex: 0 0 auto;
      margin: 0 25px;

      &:last-of-type {
        margin-right: 0;
      }

      &:first-of-type {
        margin-left: 0;
      }

      h3 {
        font-size: 18px;
      }

      .tab {
        margin-top: 14px;

        dd {
          font-size: 14px;
          color: #666666;
          line-height: 32px;
          cursor: pointer;
          &:hover{
            color: $theme_blue;
          }
        }
      }

      .QR {
        display: flex;
        margin-top: 20px;

        dd {
          margin-right: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;

          &:last-of-type {
            margin-right: 0;
          }

          img {
            width: 100px;
            height: 100px;
            border-radius: 6px;
            overflow: hidden;
          }

          span {
            font-size: 12px;
            margin-top: 8px;
          }
        }
      }
    }


  }
</style>
